import { AssociationFrontPage } from '@/models/associations/association-front-page';
import { AssociationFrontPageClaims } from '@/models/associations/association-front-page-claims';
import { AssociationFrontPageSummary } from '@/models/associations/association-front-page-sumary';
import { ContactDetails } from '@/models/common/contact-details';
import { FrontPageImageType } from '@/models/common/front-page-image';
import { Link } from '@/models/common/link';
import { OtherLinks } from '@/models/common/other-links';
import { axiosService } from '.';

export default class AssociationFrontPagesService {
    public async getFrontPage(associationId: number): Promise<AssociationFrontPage> {
        const associationFrontPageData = (await axiosService.instance.get(`associations/organization/front-page/${associationId}`)).data;
        return new AssociationFrontPage(associationFrontPageData ? associationFrontPageData : { associationId });
    }

    public async getFrontPageSummary(associationId: number): Promise<AssociationFrontPageSummary> {
        const associationFrontPageSummaryData = (await axiosService.instance.get(`associations/organization/front-page/${associationId}/summary`)).data;
        return new AssociationFrontPageSummary(associationFrontPageSummaryData ? associationFrontPageSummaryData : { associationId });
    }

    public async updateImage(associationId: number, imageType: FrontPageImageType, imageFile: File): Promise<string> {
        const formData = new FormData();
        formData.append(imageFile.name, imageFile);

        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/update-image-data/${FrontPageImageType[imageType]}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
    }

    public async updateClaims(associationId: number, claims: AssociationFrontPageClaims): Promise<boolean> {
        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/update-claims-data`, claims)).data;
    }

    public async updateDescription(associationId: number, description: string): Promise<boolean> {
        const Entities = require('html-entities').AllHtmlEntities;
        const entities = new Entities();

        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/update-description`, { description: entities.encode(description) })).data;
    }

    public async updateSocialMediaLinks(associationId: number, socialMediaLinks: Link[]): Promise<boolean> {
        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/social-media-data`, socialMediaLinks)).data;
    }

    public async updatOtherLinks(associationId: number, links: OtherLinks): Promise<boolean> {
        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/update-links`, links)).data;
    }

    public async updateContactDetails(associationId: number, contactDetails: ContactDetails): Promise<boolean> {
        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/update-contact-details`, contactDetails)).data;
    }

    public async checkIfSlugExists(associationId: number, slug: string): Promise<boolean> {
        return (await axiosService.instance.get(`associations/organization/front-page/${associationId}/check-if-slug-exists?slug=${slug}`)).data;
    }

    public async updateSlug(associationId: number, slug: string): Promise<boolean> {
        if (!slug) {
            slug = '';
        }

        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/update-slug?slug=${slug}`)).data;
    }

    public async discardChanges(associationId: number): Promise<boolean> {
        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/discard-changes`)).data;
    }

    public async applyChanges(associationId: number): Promise<boolean> {
        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/apply-changes`)).data;
    }

    public async publish(associationId: number): Promise<boolean> {
        return (await axiosService.instance.post(`associations/organization/front-page/${associationId}/publish`)).data;
    }
}

export const associationFrontPagesService = new AssociationFrontPagesService();
